/** @format */

import {ReactNode} from 'react'

import {FeatureId, useAccountContext} from '@src/contexts'
import type {Account} from '@src/types/Account'
import type {Form} from '@src/types/Form'

type RequireFeatureProps = {
  children: ReactNode
  fallback?: ReactNode
  feature: FeatureId
  on?: Account | Form
}

export function RequireFeature(props: RequireFeatureProps) {
  const {children, fallback = null, feature, on} = props
  const {account} = useAccountContext()
  const {features} = on ?? account
  return features[feature] ? children : fallback
}
